import { render } from "./SectionMain.vue?vue&type=template&id=3d6dce9e&scoped=true"
import script from "./SectionMain.vue?vue&type=script&lang=js"
export * from "./SectionMain.vue?vue&type=script&lang=js"

import "./SectionMain.vue?vue&type=style&index=0&id=3d6dce9e&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6dce9e"]])

export default __exports__